import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';
@Pipe({
  name: 'formatMessage'
})
export class FormatMessagePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // Convert Markdown to HTML
    let formattedValue = marked.parse(value, { async: false });

    // Bold titles (e.g., <h1>, <h2>, etc.)
    formattedValue = formattedValue.replace(
      /<h\d>(.*?)<\/h\d>/g,
      (match: string, p1: string): string => {
        return `<h3><strong>${p1}</strong></h3>`;
      }
    );

    return formattedValue;
  }
}
